import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createBlock(_component_IconBase, {
    width: _ctx.iconSize,
    height: _ctx.iconSize,
    "view-box": `0 0 40 40`,
    "icon-color": "transparent"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.iconComponent), {
        "icon-color": _ctx.iconColor,
        "bg-color": _ctx.bgColor
      }, null, 8, ["icon-color", "bg-color"]))
    ]),
    _: 1
  }, 8, ["width", "height"]))
}